import http from "../utils/http";

export const getPropertyTypes = async (): Promise<Response> => {
  return await http.get(`/api/property-types`);
};
